import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import '../styles/Blogs/Blogs.css';

const BLOG_POSTS = [
  {
    slug: 'held-to-maturity-interest-rate-risk',
    category: 'Actuarial Perspective',
    readTime: '7 min read',
    title: 'Held to Maturity, But Not Risk-Free: Rethinking Interest Rate Risk in Insurance',
    excerpt:
      'A bond may repay its full face value at maturity, but that does not make an insurer immune to interest rate risk. The answer changes depending on whether we look through an accounting or solvency lens.',
    author: 'Bonface',
    date: 'August 2026',
    tag: 'ALM & Solvency',
  },
  {
    slug: 'risk-management-money-on-the-table',
    category: 'Industry Insights',
    readTime: '5 min read',
    title: 'Why Most Businesses Are Leaving Money on the Table with Poor Risk Management',
    excerpt:
      'Every year, businesses across Africa lose billions to risks they never saw coming — not because those risks were unpredictable, but because no one was looking in the right direction.',
    author: 'Actyra Advisory Team',
    date: 'June 2026',
    tag: 'Risk Management',
  },
  // Add future blog posts here
];

export default function Blogs() {
  return (
    <>
      <Navbar />
      <main className="blogs-page">
        {/* Hero */}
        <section className="blogs-hero">
          <div className="blogs-hero-inner">
            <span className="blogs-hero-eyebrow">From the desk of Actyra</span>
            <h1 className="blogs-hero-title">
              Insights &amp; <span className="blogs-hero-accent">Perspectives</span>
            </h1>
            <p className="blogs-hero-sub">
              Practical thinking on risk, capital, and the decisions that shape African business.
            </p>
          </div>
          <div className="blogs-hero-line" aria-hidden="true" />
        </section>

        {/* Grid */}
        <section className="blogs-grid-section">
          <div className="blogs-grid">
            {BLOG_POSTS.map((post) => (
              <article key={post.slug} className="blog-card">
                <div className="blog-card-meta">
                  <span className="blog-card-category">{post.category}</span>
                  <span className="blog-card-dot" aria-hidden="true" />
                  <span className="blog-card-read">{post.readTime}</span>
                </div>
                <h2 className="blog-card-title">{post.title}</h2>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <div className="blog-card-footer">
                  <div className="blog-card-author-row">
                    <div className="blog-card-author-avatar" aria-hidden="true">
                      {post.author.charAt(0)}
                    </div>
                    <div className="blog-card-author-info">
                      <span className="blog-card-author-name">{post.author}</span>
                      <span className="blog-card-date">{post.date}</span>
                    </div>
                  </div>
                  <Link to={`/blogs/${post.slug}`} className="blog-card-cta">
                    <span>Read</span>
                    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                      <path
                        d="M4 10h12M11 5l5 5-5 5"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </div>
                <div className="blog-card-tag">{post.tag}</div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}
